
// ReSharper disable InconsistentNaming
define('coach/cumulative/view/views/dashboard-view',['jquery',
        '_',
        'backbone',
        'backbone.marionette',
        'hbs!../templates/dashboard',
        './game-chooser-view',
        'smooth-modal',
        'lib/kickoff/svg-replacer',
        'actionclick',
        'model',
        'services',
        'usage-log-event'
    ],
    function ($, _, Backbone, Marionette, dashboardTemplate, gameChooserDialogView, SmoothModal, svgReplacer, actionClick, model, services, UsageLogEvent) {
        'use strict';

        var DashboardView = Marionette.LayoutView.extend({
            id: 'dashboard-view',
            template: dashboardTemplate,
            events: {
                'actionclick .notifications-area span.icon-close': '_renderNotification',
                'actionclick .ko-season-toggle-forward': '_nextSeasonClicked',
                'actionclick .ko-season-toggle-back': '_previousSeasonClicked',
                'actionclick .back': '_backClicked',
                'actionclick .admin-dialog': '_adminDialogClicked'
            },
            modelEvents: {
                'model-updated': '_modelUpdated',
                'closeDialog': '_closeDialog',
            },
            regions: {
                dialogRegion: SmoothModal
            },
            initialize: function (options) {
            },
            onRender: function () {
                this.$('img[src$=".svg"]').each(svgReplacer);

                this.$('#dashboard-sections').addClass('on-stage');
            },
            _modelUpdated: function () {

                this.$('#season-loading').removeClass('season-spinner');

                this.$('.ko-season-toggle-back').toggleClass('hidden', !this.model.get('previousSeasonId'));
                this.$('.ko-season-toggle-forward').toggleClass('hidden', !this.model.get('nextSeasonId'));
                this.$('.selected-season').text(this.model.get('season').seasonLabel);
                $('.game-stats').attr('href', this.model.get('gameStatsUrl'));
            },
            _backClicked: function() {
                if (this._confirmDiscardEdits()) {
                    Backbone.history.navigate('', { trigger: true });
                }
            },
            _closeDialog: function() {
                this.dialogRegion.close();
            },
            _nextSeasonClicked: function () {
                this._navigateToSeason(this.model.get('nextSeasonId'));
                window.location.href = this.model.get('nextSeasonUrl');
            },
            _previousSeasonClicked: function () {
                this._navigateToSeason(this.model.get('previousSeasonId'));
                window.location.href = this.model.get('previousSeasonUrl');
            },
            log: function(logData) {
                this.usageLog = new UsageLogEvent({
                    logger: 'CumulativeStatisticsCoachUsage'
                });
                this.usageLog.log(logData);
            },
            _navigateToSeason: function(seasonId) {
                Backbone.history.navigate('season/' + seasonId + '/cumulative', { trigger: true });
                this.$('#season-loading').addClass('season-spinner');
            }           

        });

        return DashboardView;
    });
